import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../api";
import "./CollegeAcademics.css";

const cards = [
  {
    title: "Programs & Semesters",
    text: "Use the existing Classes engine for program + semester combinations, e.g. BCA - Semester 1.",
    path: "/classes",
    icon: "bi-mortarboard",
    action: "Manage programs / semesters",
  },
  {
    title: "Batches & Sections",
    text: "Use existing Sections for college batches or sections. All attendance, fees and timetable links continue to work.",
    path: "/sections",
    icon: "bi-collection",
    action: "Manage batches / sections",
  },
  {
    title: "Papers & Subjects",
    text: "Use the same Subjects master for theory, practical and elective papers without duplicating academic data.",
    path: "/subjects",
    icon: "bi-journal-bookmark",
    action: "Manage papers / subjects",
  },
  {
    title: "Subject Registration",
    text: "Configure core, elective and optional papers, credits, choice rules and student subject selection.",
    path: "/college-subject-registration",
    icon: "bi-ui-checks-grid",
    action: "Configure subject registration",
  },
  {
    title: "Internal + External Examination",
    text: "Configure internal assessment, university/external exam, practical, viva and assignment weightage; publish final result directly into SGPA / CGPA.",
    path: "/college-examinations",
    icon: "bi-journal-check",
    action: "Open college examinations",
  },
  {
    title: "Credits · SGPA · CGPA",
    text: "Configure grade points, publish credit-based semester grades and calculate SGPA / cumulative CGPA automatically.",
    path: "/college-academic-progress",
    icon: "bi-award-fill",
    action: "Open academic progress",
  },
  {
    title: "University Registration · Enrollment",
    text: "Maintain university registration number, roll number, enrollment ID, admission batch, ABC/APAAR and migration details for every student.",
    path: "/college-enrollment",
    icon: "bi-person-vcard-fill",
    action: "Manage university enrollment",
  },
  // COLLEGE_STUDENT_360_CARD_V1
  {
    title: "360° Student Academic Profile",
    text: "See enrollment, registered papers, lecture attendance, grades, SGPA/CGPA, backlogs, documents and placement journey in one student view.",
    path: "/college-student-360",
    icon: "bi-person-bounding-box",
    action: "Open 360° student profile",
  },
  // COLLEGE_CONVOCATION_DEGREE_CARD_V1
  {
    title: "Convocation & Degree Issuance",
    text: "Check graduation eligibility from credits, backlogs, project/internship and No-Dues; manage convocation registration, provisional certificates, degree serials and collection status.",
    path: "/college-graduation",
    icon: "bi-mortarboard-fill",
    action: "Open graduation lifecycle",
  },
  {
    title: "Grade Card · Transcript",
    text: "Generate semester grade cards and consolidated transcripts with internal/external marks, credits, SGPA, CGPA, backlog status and university identity details.",
    path: "/college-grade-cards",
    icon: "bi-file-earmark-bar-graph-fill",
    action: "Open academic documents",
  },
  {
    title: "Backlog / Reappear",
    text: "Track failed or absent papers, reappear registrations, attempt history and automatic clearance into SGPA / CGPA.",
    path: "/college-backlogs",
    icon: "bi-arrow-counterclockwise",
    action: "Manage backlog / reappear",
  },
  // STUDENT_MENTORING_SUPPORT_COLLEGE_CARD_V1
  {
    title: "Student Mentoring & Support",
    text: "Assign faculty mentors, track attendance / CGPA / backlogs, record meetings, action plans and follow-ups from one student-success workspace.",
    path: "/student-mentoring",
    icon: "bi-person-heart",
    action: "Open mentoring",
  },
  // COLLEGE_STUDENT_REQUESTS_CARD_V1
  {
    title: "Certificates & Student Requests",
    text: "Let students request bonafide, NOC, provisional, migration and other official documents; track approval, fees, issue status and downloadable PDFs.",
    path: "/college-student-requests",
    icon: "bi-file-earmark-check-fill",
    action: "Open student requests",
  },
  // COLLEGE_INTERNSHIP_MANAGEMENT_CARD_V1
  {
    title: "Internship Management",
    text: "Manage industrial training, companies, mentors, student logbooks, progress reports, documents, completion certificates and final evaluation.",
    path: "/college-internships",
    icon: "bi-building-check",
    action: "Open internship management",
  },
  // COLLEGE_PROJECT_DISSERTATION_CARD_V1
  {
    title: "Projects / Dissertation",
    text: "Manage student or group projects, guides, milestones, report submissions, reviews, viva and final evaluation from one academic workflow.",
    path: "/college-projects",
    icon: "bi-kanban-fill",
    action: "Open project management",
  },
  // STUDENT_CLUBS_ACTIVITIES_CARD_V1
  {
    title: "Clubs, Societies & Activities",
    text: "Manage student clubs, memberships, competitions, activity points, service hours, participation and certificates.",
    path: "/clubs-activities",
    icon: "bi-trophy-fill",
    action: "Open student activities",
  },
  // ALUMNI_ENGAGEMENT_CARD_V1
  {
    title: "Alumni & Engagement",
    text: "Manage alumni profiles, batch directory, reunions, achievements, mentoring and career referrals in one lifelong community network.",
    path: "/alumni-engagement",
    icon: "bi-mortarboard-fill",
    action: "Open alumni network",
  },
  // SCHOLARSHIP_FREESHIP_COLLEGE_CARD_V1
  {
    title: "Scholarships & Financial Aid",
    text: "Government, institutional and private scholarships, freeships, document verification, sanction, disbursement and fee-benefit linkage.",
    path: "/scholarships",
    icon: "bi-award-fill",
    action: "Open scholarships",
  },
  // COLLEGE_RESEARCH_RD_CARD_V1
  {
    title: "Research & Publications / R&D",
    text: "Track publications, Scopus/WoS indexing, funded research, grants, patents/IPR, conferences/FDPs and verification-ready evidence with NAAC/IQAC snapshots.",
    path: "/research-publications",
    icon: "bi-journal-richtext",
    action: "Open R&D workspace",
  },
  // COLLEGE_NAAC_IQAC_CARD_V1
  {
    title: "NAAC / IQAC & Accreditation",
    text: "Manage accreditation cycles, criteria, metric ownership, ERP data snapshots, evidence verification, IQAC activities and readiness progress.",
    path: "/naac-iqac",
    icon: "bi-award-fill",
    action: "Open accreditation workspace",
  },
  // COLLEGE_HOSTEL_MANAGEMENT_CARD_V1
  {
    title: "Hostel Management",
    text: "Manage hostels, rooms and beds, student allocation, night roll call, outing/gate passes, visitors, maintenance complaints and hostel charges.",
    path: "/college-hostel",
    icon: "bi-building-fill-gear",
    action: "Open Hostel Management",
  },
  // COLLEGE_STUDENT_LEAVE_OD_CARD_V1
  {
    title: "Student Leave & On-Duty",
    text: "Manage medical/personal leave and official OD for sports, placement, internship, events or university duty with lecture-level attendance protection.",
    path: "/college-student-leave",
    icon: "bi-calendar2-check-fill",
    action: "Open Leave / OD",
  },
  // COLLEGE_FACULTY_WORKLOAD_CARD_V1
  {
    title: "Faculty Workload",
    text: "Calculate weekly lecture, practical and tutorial hours from the timetable, compare faculty targets, and flag overloaded or underloaded staff.",
    path: "/college-faculty-workload",
    icon: "bi-person-workspace",
    action: "Review faculty workload",
  },
  {
    title: "Placement & Career Cell",
    text: "Manage recruiters, placement drives, eligible programs, applications, selection rounds, offers and joining outcomes.",
    path: "/placement-cell",
    icon: "bi-briefcase-fill",
    action: "Open Placement Cell",
  },
];

export default function CollegeAcademics() {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    api.get("/schools/current/profile")
      .then(({ data }) => {
        if (!active) return;
        setProfile(data?.institution || data || null);
        const type = String(data?.institution?.institution_type || data?.institution_type || "school").toLowerCase();
        localStorage.setItem("institutionType", type);
      })
      .catch(() => {})
      .finally(() => active && setLoading(false));
    return () => { active = false; };
  }, []);

  const type = String(profile?.institution_type || localStorage.getItem("institutionType") || "school").toLowerCase();

  return (
    <div className="container py-4 college-academics-page">
      <div className="college-academics-hero mb-4">
        <div>
          <span className="college-academics-kicker">EduBridge ERP</span>
          <h1 className="h3 mb-2">College Academics</h1>
          <p className="mb-0 text-muted">
            One academic setup layer for programs, semesters, batches and papers while keeping the same ERP/LMS engine.
          </p>
        </div>
        <span className={`badge rounded-pill ${type === "college" ? "text-bg-primary" : "text-bg-secondary"}`}>
          {loading ? "Checking institution…" : type === "college" ? "College Mode" : "School Mode"}
        </span>
      </div>

      {type !== "college" && !loading && (
        <div className="alert alert-info border-0 shadow-sm">
          This institution is currently configured as <strong>School</strong>. Super Admin can change it from Institutions Management.
        </div>
      )}

      <div className="row g-3">
        {cards.map((card) => (
          <div className="col-12 col-lg-4" key={card.path}>
            <div className="card h-100 border-0 shadow-sm college-academics-card">
              <div className="card-body p-4">
                <div className="college-academics-icon mb-3"><i className={`bi ${card.icon}`} /></div>
                <h2 className="h5">{card.title}</h2>
                <p className="text-muted">{card.text}</p>
                <Link className="btn btn-outline-primary btn-sm" to={card.path}>{card.action}</Link>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="card border-0 shadow-sm mt-4">
        <div className="card-body p-4">
          <h2 className="h5 mb-3">What stays shared with School ERP</h2>
          <div className="row g-2 small">
            {["Admissions", "Students", "Fees", "Attendance", "HR & Payroll", "Library", "Inventory", "Transport", "Departments", "Examinations", "LMS", "Learning Resources", "Online Classes", "Reports"].map((item) => (
              <div className="col-6 col-md-4 col-xl-3" key={item}>
                <div className="college-shared-item"><i className="bi bi-check-circle-fill me-2" />{item}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="alert alert-light border mt-4 mb-0">
        <strong>Recommended data convention:</strong> create class records as <code>BCA - Semester 1</code>, <code>BCA - Semester 2</code>, etc. This keeps your existing fee, attendance, timetable, exam and LMS workflows compatible immediately.
      </div>
    </div>
  );
}
